import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Box, List, Paper, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import tgsrtcLogo from '../../assets/images/tgsrtc-logo.svg';
import NavButton from '../../common/components/NavButton';
import DashboardIcon from '../../iconComponent/dashboardIcon';
import TripsIcon from '../../iconComponent/tripsIcon';
import ReportsIcon from '../../iconComponent/reportsIcon';
import AllReportsIcon from '../../iconComponent/ReportsIcon1';
import ScheduleReportsIcon from '../../iconComponent/clockIcon';
import DirectoriesIcon from '../../iconComponent/direcoriesIcon';
import AdminIcon from '../../iconComponent/adminIcon';
import AlarmIcon from '../../iconComponent/alarmIcon';
import RouteIcon from '@mui/icons-material/Route';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MapIcon from '@mui/icons-material/Map';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import GroupsIcon from '@mui/icons-material/Groups';
import DevicesOtherIcon from '@mui/icons-material/DevicesOther';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import VehicleAlerts from '../../iconComponent/Vehicle_Alerts';
import GeoFenceIcon from '../../iconComponent/geofenceIcon';
import DeviceIcon from '../../iconComponent/DeviceIcon';
import DocumentIcon from '../../iconComponent/DocumentBlockIcon';
import PerformanceIcon from '../../iconComponent/DriverPerformanceIcon';
import DriverIcon from '../../iconComponent/driverIcon';
import DriverAlerts from '../../iconComponent/DriverAlerts';
import DriverCoaching from '../../iconComponent/DriverCoaching';
import IgnitionBasedIcon from '../../iconComponent/IgnitionBasedIcon';
import TripCreationIcon from '../../iconComponent/tripCreationIcon';
import SupportIcon from '../../iconComponent/SupportIcon';
import HelpDeskIcon from '../../iconComponent/HelpDeskIcon';
import TroubleShootIcon from '../../iconComponent/TroubleShootIcon';
import BroadcastIcon from '../../iconComponent/BroadcastIcon';
import { useAuth } from '../../authContext/useAuth';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import AnalyticsIcons from '../../iconComponent/Analytics';
import UserCreation from '@mui/icons-material/PersonAdd';
import CompanyIcon from '@mui/icons-material/Business';
import UserIcon from '@mui/icons-material/Person';

import {
  getPermissionCategoryFromNavItem,
  getPermissionSubcategoryFromNavSubcategory,
  hasCategoryAccess,
  hasSubcategoryAccess,
} from '../../utils/permissionConstants';
import { ROUTE } from '../../router/Constant';

interface NavItem {
  text: string;
  icon: any;
  path: string;
  hasArrow?: boolean;
  children?: NavItem[];
  adminOnly?: boolean;
  sudperAdminOnly?: boolean;
  hideForSuperAdmin?: boolean;
  hideForLocationManager?: boolean;
}

const navArrItems: NavItem[] = [
  { text: 'Dashboard', icon: <DashboardIcon />, path: ROUTE.dashboard },
  {
    text: 'Vehicles',
    icon: <DirectionsCarIcon />,
    path: `${ROUTE.vehicles}`,
  },
  {
    text: 'Trips',
    icon: <TripsIcon />,
    path: ROUTE.trips,
    hasArrow: true,
    children: [
      {
        text: 'User Created Trips',
        icon: <TripCreationIcon />,
        path: ROUTE.trips,
      },
      {
        text: 'Ignition Based Trips',
        icon: <IgnitionBasedIcon />,
        path: ROUTE.ignitionTrips,
      },
    ],
  },
  {
    text: 'Reports',
    icon: <ReportsIcon />,
    path: ROUTE.reports,
    hasArrow: true,
    children: [
      { text: 'All Reports', icon: <AllReportsIcon />, path: ROUTE.reports },
      {
        text: 'Scheduled Reports',
        icon: <ScheduleReportsIcon />,
        path: ROUTE.scheduledReports,
      },
    ],
  },
  { text: 'Documents', icon: <DocumentIcon />, path: '/document', hideForLocationManager: true },
  {
    text: 'Alerts',
    icon: <AlarmIcon />,
    path: ROUTE.Alarm,
    hasArrow: true,
    children: [
      {
        text: 'Vehicle Alerts',
        icon: <VehicleAlerts />,
        path: `${ROUTE.Alarm}/${ROUTE.VehicleAlerts}`,
      },
      {
        text: 'Driver Alerts',
        icon: <DriverAlerts />,
        path: `${ROUTE.Alarm}/${ROUTE.DriverAlerts}`,
      },
      {
        text: 'Broadcast',
        icon: <BroadcastIcon />,
        path: `${ROUTE.Alarm}/${ROUTE.Broadcast}`,
      },
    ],
  },
  {
    text: 'Driver Performance',
    icon: <PerformanceIcon />,
    path: `${ROUTE.DriverPerformance}`,
  },
  {
    text: 'Driver Coaching',
    icon: <DriverCoaching />,
    path: `${ROUTE.DriverCoaching}`,
    hasArrow: false,
  },
  {
    text: 'Directories',
    icon: <DirectoriesIcon />,
    path: ROUTE.directories,
    hasArrow: true,
    children: [
      {
        text: 'Geofences',
        icon: <GeoFenceIcon />,
        path: `${ROUTE.directories}/${ROUTE.geofences}`,
      },
      {
        text: 'Routes',
        icon: <RouteIcon />,
        path: `${ROUTE.directories}/${ROUTE.routes}`,
      },
      {
        text: 'Addresses',
        icon: <LocationOnIcon />,
        path: `${ROUTE.directories}/${ROUTE.addresses}`,
      },
      // {
      //   text: 'Vehicles',
      //   icon: <DirectionsCarIcon />,
      //   path: `${ROUTE.directories}/${ROUTE.vehicles}`,
      // },
      {
        text: 'Depot',
        icon: <GroupsIcon />,
        path: `${ROUTE.directories}/${ROUTE.groups}`,
      },
      {
        text: 'Devices',
        icon: <DeviceIcon />,
        path: `${ROUTE.directories}/${ROUTE.devices}`,
      },
      {
        text: 'My Drivers',
        icon: <EmojiPeopleIcon />,
        path: `${ROUTE.directories}/${ROUTE.driver}`,
      },
    ],
  },
  { text: 'Analytics', icon: <AnalyticsIcons />, path: ROUTE.analytics, hideForLocationManager: true },
  {
    text: 'Service Manager',
    icon: <SupportIcon />,
    path: ROUTE.serviceMaster,
  },
  {
    text: 'Support',
    icon: <SupportIcon />,
    path: ROUTE.support,
    hasArrow: true,
    hideForLocationManager: true,
    children: [
      {
        text: 'HelpDesk',
        icon: <HelpDeskIcon />,
        path: `${ROUTE.support}/${ROUTE.helpDesk}`,
      },
    ],
  },
  {
    text: 'Admin',
    icon: <AdminIcon />,
    path: ROUTE.admin,
    hasArrow: true,
    hideForLocationManager: true,
    children: [
      {
        text: 'Customization',
        icon: <DashboardCustomizeIcon />,
        path: `${ROUTE.admin}/${ROUTE.customization}`,
      },
      {
        text: 'Live Stream Config',
        icon: <SettingsSuggestIcon />,
        path: `${ROUTE.admin}/${ROUTE.liveStreamConfig}`,
      },
      {
        text: 'User Access Controls',
        icon: <AccessibilityNewIcon />,
        path: `${ROUTE.admin}/${ROUTE.userAccessControls}`,
      },
      {
        text: 'User Creation',
        icon: <UserCreation />,
        path: '/admin/user-creation',
        hasArrow: true,
        children: [
          {
            text: 'Company',
            icon: <CompanyIcon />,
            path: '/admin/user-creation/company',
            sudperAdminOnly: true, // 👈 only ROLE_SUPER_ADMIN
          },
          {
            text: 'User',
            icon: <UserIcon />,
            path: '/admin/user-creation/user',
          },
        ],
      },
      {
        text: 'Banner Configuration',
        icon: <ViewCarouselIcon />,
        path: `${ROUTE.admin}/${ROUTE.userBannerCreate}`,
      },
      {
        text: 'Manage Subscriptions',
        icon: <SubscriptionsIcon />,
        path: `${ROUTE.admin}/${ROUTE.manageSubscriptions}`,
        adminOnly: true,
      },
      {
        text: 'Manage Subscriptions',
        icon: <SubscriptionsIcon />,
        path: `${ROUTE.admin}/${ROUTE.internalSubscriptions}`,
        sudperAdminOnly: true,
      },
    ],
  },
];

// ✅ Recursive helper to filter children at any nesting depth
const filterNavChildren = (
  children: NavItem[],
  authorities: string | undefined,
  permissionCategory: string | undefined,
  permission: any,
  user: any,
): NavItem[] => {
  return children
    .filter((child) => {
      const isAdmin = authorities === 'ROLE_ADMIN';
      const isSuperAdmin = authorities === 'ROLE_SUPER_ADMIN';

      // Role-based filtering
      if (child.adminOnly || child.sudperAdminOnly) {
        if (child.adminOnly && child.sudperAdminOnly) {
          if (!isAdmin && !isSuperAdmin) return false;
        } else if (child.adminOnly) {
          if (!isAdmin) return false;
        } else if (child.sudperAdminOnly) {
          if (!isSuperAdmin) return false;
        }
      }

      // Hide for location manager
      if (child.hideForLocationManager && authorities === 'ROLE_LOCATION_MANAGER') return false;

      // Permission-based filtering
      const permissionSubcategory = getPermissionSubcategoryFromNavSubcategory(child.text);
      if (permissionCategory && permissionSubcategory) {
        return hasSubcategoryAccess(permission, permissionCategory, permissionSubcategory, user);
      }

      return true;
    })
    .map((child) => {
      // Recursively filter grandchildren
      if (child.children) {
        return {
          ...child,
          children: filterNavChildren(child.children, authorities, permissionCategory, permission, user),
        };
      }
      return child;
    });
};

const NavBar: React.FC<{ opened: (isOpen: boolean) => void }> = ({ opened }) => {
  const [isOpen, setIsOpen] = useState(false);
  const theme = useTheme();
  const location = useLocation();
  const { user, permission } = useAuth();
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery('(max-width:850px)');

  const navItems = useMemo(() => {
    const authorities = user?.authorities;

    const filteredNavItems = navArrItems
      .filter((item) => {
        if (item.hideForSuperAdmin && authorities === 'ROLE_SUPER_ADMIN') return false;
        if (item.hideForLocationManager && authorities === 'ROLE_LOCATION_MANAGER') return false;

        if (item.adminOnly || item.sudperAdminOnly) {
          const isAdmin = authorities === 'ROLE_ADMIN';
          const isSuperAdmin = authorities === 'ROLE_SUPER_ADMIN';

          if (item.adminOnly && item.sudperAdminOnly) {
            if (!isAdmin && !isSuperAdmin) return false;
          } else if (item.adminOnly) {
            if (!isAdmin) return false;
          } else if (item.sudperAdminOnly) {
            if (!isSuperAdmin) return false;
          }
        }

        const permissionCategory = getPermissionCategoryFromNavItem(item.text);
        if (permissionCategory) {
          return hasCategoryAccess(permission, permissionCategory, user);
        }

        return true;
      })
      .map((item) => {
        if (item.children) {
          const permissionCategory = getPermissionCategoryFromNavItem(item.text);
          return {
            ...item,
            // ✅ Uses recursive function instead of flat filter
            children: filterNavChildren(
              item.children,
              authorities,
              permissionCategory ?? undefined,
              permission,
              user,
            ),
          };
        }
        return item;
      });

    return filteredNavItems;
  }, [user?.authorities, permission]); // ✅ depend on user?.authorities not user

  const [activeItem, setActiveItem] = useState<string>(
    navItems.find((item) => location.pathname.startsWith(item.path))?.text || 'Dashboard',
  );

  const [openItems, setOpenItems] = useState<{ [key: string]: boolean }>({});

  useEffect(() => {
    opened(isOpen);
  }, [isOpen, opened]);

  useEffect(() => {
    setActiveItem(navItems.find((item) => location.pathname.startsWith(item.path))?.text || 'Dashboard');
  }, [location.pathname]);

  const handleNavItemClick = (item: NavItem) => {
    if (item.children) {
      setOpenItems((prev) => ({
        ...prev,
        [item.text]: !prev[item.text],
      }));
    } else {
      setActiveItem(item.text);
      navigate(item.path);
    }
  };

  const hoverTimerRef = useRef<NodeJS.Timeout | null>(null);

  const renderNavItems = (items: NavItem[], level: number = 0) => {
    return items.map((item) => {
      const isActive = activeItem === item.text;
      const icon = typeof item.icon === 'function' ? item.icon(isActive) : item.icon;

      return (
        <Box key={item.text} sx={{ pl: level * 1.5 }}>
          <NavButton
            text={item.text}
            icon={icon}
            hasArrow={item.hasArrow}
            isActive={isActive}
            isOpen={isOpen && !isSmallScreen}
            onClick={() => handleNavItemClick(item)}
            arrowRotated={!!openItems[item.text]}
          />
          {item.children && openItems[item.text] && renderNavItems(item.children, level + 0.5)}
        </Box>
      );
    });
  };

  return (
    <Paper
      onMouseEnter={() => {
        if (!isSmallScreen) {
          if (hoverTimerRef.current) clearTimeout(hoverTimerRef.current);
          hoverTimerRef.current = setTimeout(() => setIsOpen(true), 100);
        }
      }}
      onMouseLeave={() => {
        if (!isSmallScreen) {
          if (hoverTimerRef.current) clearTimeout(hoverTimerRef.current);
          hoverTimerRef.current = setTimeout(() => setIsOpen(false), 100);
        }
      }}
      sx={{
        width: isSmallScreen ? '56px' : isOpen ? '300px' : '96px',
        padding: isSmallScreen ? '6px' : '24px',
        background: theme.palette.selected,
        transition: 'width 0.4s ease-in-out, padding 0.3s ease-in-out',
        overflowX: 'hidden',
        position: 'relative',
      }}
      className="h-full flex flex-col gap-[24px]"
    >
      {/* Navbar Header */}
      <Box className="flex items-center justify-start gap-2 min-w-0">
        <img
          src={tgsrtcLogo}
          alt="TGSRTC"
          className={isOpen && !isSmallScreen ? 'h-[76px] w-[76px]' : 'h-[56px] w-[56px]'}
        />
        {isOpen && !isSmallScreen && (
          <Typography
            variant="subtitle1"
            noWrap
            sx={{
              fontWeight: 700,
              fontSize: '22px',
              lineHeight: '28px',
              letterSpacing: '0.02em',
              color: theme.palette.text.primary,
            }}
          >
            TGSRTC
          </Typography>
        )}
      </Box>

      {/* Navbar List */}
      <List
        className="mt-8 flex flex-col gap-[16px]"
        sx={{
          overflowY: 'auto',
          overflowX: 'hidden',
          flex: 1,
          '&::-webkit-scrollbar': {
            display: 'none',
          },
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
        }}
      >
        {renderNavItems(navItems)}
      </List>
    </Paper>
  );
};

export default NavBar;
